<template>
	<v-container fill-height fluid style="flex-wrap: wrap;">
		<pvcam-wc-user :on="invite" org="Provision Cameramatics" />
		<div class="mx-auto">
			<v-btn
				large
				class="mx-0 font-weight-light"
				color="success"
				target="_blank"
				rounded
				@click.stop="invite++"
			>
				<v-icon left>mdi-material-design</v-icon>
				<span>See all icons</span>
			</v-btn>
		</div>
	</v-container>
</template>

<script>
export default {
	data: () => ({invite: 0})
}
</script>
